<span
  class="tw-icon"
  v-html="iconSvgText(icon)"
  v-bind="$attrs"
/>
